import { analytics } from '../analytics';

const relatedContentBlogSelector = '.mhecomm-relatedblogcontent-item';

export function registerRelatedContentBlogAnalytics(): void {

  const relatedContentBlogAnalytics = analytics(relatedContentBlogSelector)
    .name('related-content-blog-view')
    .on('DOMContentLoaded')
    .collectCommon()
    .unset('expanded')
    .enrich(({ element }) => {
      const { parentId: id, eventnameView: eventname } = (element as HTMLElement).dataset;
      return { id, eventname };
    });

  relatedContentBlogAnalytics.emit('view');
}
